import { SERVICES, SERVICE_GROUPS } from '../../../../components/myeirconstant/myEirConstant';
import getGeneralImage from '../getGeneralImage';
import { getUserOtc } from '../userOtc.api';

const { DUALPLAY, DUALPLAY_PSTN, SA_PSTN, TV, MOBILE, MBB } = SERVICE_GROUPS;
/**
 * @function getTileImage -Function to get relevent tile images
 * @param {*} props - Strapi Data
 * @returns {string} - Responsive images based on desktop,mobile and tablet view
 */
export const getTileImage = props => {
    const troubleTileMobile = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Tile_images,
            key: 'tileBackground',
            view: 'MobileViewImage',
        }).url
    }`;
    const troubleTileTablet = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Tile_images,
            key: 'tileBackground',
            view: 'TabletViewImage',
        }).url
    }`;
    const troubleTileDesktop = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Tile_images,
            key: 'tileBackground',
            view: 'DesktopViewImage',
        }).url
    }`;
    const troubleTileForegroundDesktop = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Tile_images,
            key: 'tileForeground',
            view: 'DesktopViewImage',
        }).url
    }`;
    const troubleTileForegroundTablet = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Tile_images,
            key: 'tileForeground',
            view: 'TabletViewImage',
        }).url
    }`;
    const troubleTileForegroundMobile = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Tile_images,
            key: 'tileForeground',
            view: 'MobileViewImage',
        }).url
    }`;
    return {
        troubleTileMobile,
        troubleTileDesktop,
        troubleTileTablet,
        troubleTileForegroundDesktop,
        troubleTileForegroundMobile,
        troubleTileForegroundTablet,
    };
};

export const getServiceDetails = (serviceGroups, serviceIssues) => {
    const dualPlaySubs =
        serviceGroups.includes(DUALPLAY) ||
        serviceGroups.includes(DUALPLAY_PSTN) ||
        serviceGroups.includes(SA_PSTN);
    const tvSubs = serviceGroups.includes(TV);
    const mobileSubs = serviceGroups.includes(MOBILE);
    const mobileBroadbandSubs = serviceGroups.includes(MBB);

    if (dualPlaySubs && tvSubs && mobileSubs) {
        return serviceIssues.find(
            issue => issue.services === SERVICES.BROADBAND_LANDLINE_TV_MOBILE
        );
    } else if (dualPlaySubs && tvSubs) {
        return serviceIssues.find(issue => issue.services === SERVICES.BROADBAND_LANDLINE_TV);
    } else if (dualPlaySubs && mobileSubs) {
        return serviceIssues.find(issue => issue.services === SERVICES.BROADBAND_LANDLINE_MOBILE);
    } else if (dualPlaySubs) {
        return serviceIssues.find(issue => issue.services === SERVICES.BROADBAND_LANDLINE);
    } else if (mobileSubs) {
        return serviceIssues.find(issue => issue.services === SERVICES.MOBILE);
    } else if (mobileBroadbandSubs) {
        return serviceIssues.find(issue => issue.services === SERVICES.MBB);
    } else {
        return serviceIssues.find(
            issue => issue.services === SERVICES.BROADBAND_LANDLINE_TV_MOBILE
        );
    }
};

/**
 * @name getUserOTCInfo
 * @description Fetches data from the GRAPHQL API
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @returns {Promise<void>} Promise and sets the state clientSideGRAPHQL when resolved
 */
export const getUserOTCInfo = async ({ graphql, setSweeprParams, toggleError }) => {
    try {
        setSweeprParams({ OTC: null });
        const res = await getUserOtc({ graphql });
        if (res?.data?.userOtc) {
            setSweeprParams({ OTC: res?.data?.userOtc?.onetimecode });
        }
        return res;
    } catch (error) {
        toggleError();
        return error;
    }
};
